import React from 'react'
import InputMask from 'react-input-mask';
import Calendar from 'react-calendar';
import { BsCalendar } from "react-icons/bs";
import {JustDate} from '../model/JustDate';
import '../css/Calendar.css';

class DateTextField extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)

        const date = (!props.value) ? undefined : JustDate.from(props.value)

        this.state = {
            value: this.getStringDate(date),
            lastDate: date,
        }
    }

    getStringDate(date) {
        if (!date) {
            return 'NaN/NaN/NaN'
        }

        let month = date.getMonth() + 1
        if (month < 10) { month = '0' + month }

        let day = date.getDate()
        if (day < 10) { day = '0' + day }

        let year = date.getFullYear()

        const text = '' + month + '/' +
                day + '/' + year

        return text
    }

    onTextUpdated(e) {
        const text = e.target.value
        this.setState({
            value: text,
        })

        const dText = text.replaceAll(/[^0-9]/g, '')

        let d = new JustDate()

        if (dText.length > 7) {
            d.setFullYear(parseInt(dText.substring(4, 8)))
        }

        if (dText.length > 3) {
            d.setDate(parseInt(dText.substring(2, 4)))
        }

        if (dText.length > 1) {
            d.setMonth(parseInt(dText.substring(0, 2)) - 1)
        }

        if (dText.length === 0) {
            this.props.onChange(undefined)
        }
        if (dText.length > 7) {
            this.props.onChange(d)
        }
    }

    render() {
        const date = new JustDate(this.props.value)
        if (this.state.value === 'NaN/NaN/NaN' &&
            this.state.lastDate !== date && !isNaN(date.getFullYear())) {
            this.setState({
                value: this.getStringDate(date),
                lastDate: date,
            })
        }

        return <div style={{
            'position': 'sticky',
        }}>
            <InputMask
                style={{'width': 'calc(100% - 38px)', ...this.props.style}}
                className="form-control"
                value={this.state.value}
                onChange={(e) => this.onTextUpdated(e)}
                mask="99/99/9999"
                placeholder="Enter date"
                onKeyDown={this.props.onKeyDown}
                />
            <BsCalendar style={{
                'top': '9px',
                'position': 'absolute',
                'right': '8px',
            }} onClick={(e) => { 
                this.props.showModal(
                    <Calendar
                        style={{
                            'border': 'none',
                            'width': '100%',
                        }}
                        onChange={(d) => {
                            d = JustDate.from(d)
                            this.props.onChange(d)
                            this.setState({
                                'value': this.getStringDate(d),
                                'lastDate': d,
                            })
                            this.props.closeModal()
                        }}
                        value={this.state.lastDate ?
                            this.state.lastDate.toDateTime() : new Date()}
                        />
                )
            }}/>
        </div>
    }
}

export default DateTextField
